import { cloneDeep } from 'libs/common';
import { weekdayNumberFields, weekdayToggleFields } from './tarifficators/weekday/weekday.config';

// number fields
export const numberFields = ['subscription_period'];
export const igoraNumberFields = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'holiday'];
export const parmaNumberFields = ['day_cost', 'night_cost'];
export const menskingsNumberFields = ['day_cost', 'night_cost'];
export const hdnNumberFields = ['day_hour_cost', 'night_hour_cost', 'night_amount_limit', 'day_amount_limit'];
export const dailyNumberFields = ['day_cost'];

// data fields
export const dataFields = [
  'subscription_period',
  'subscription_period_unit',
  'subscription_amount',
  'secondentry_amount',
  'secondentry_period',
  'secondentry_duration',
  'secondentry_count_min',
  'secondentry_duration_max',
  'secondentry_use_previous',
];

// price fields
export const priceFields = ['subscription_amount', 'secondentry_amount'];

// second fields
export const secondFields = ['secondentry_interval', 'secondentry_duration', 'secondentry_period', 'time_to_leave', 'secondentry_duration_max', 'time_limit'];

/**
 * weekday zone: toggles are booleans, costs and free intervals are non-negative integers (empty/missing -> 0)
 * @param {*} zone
 */
const normalizeWeekdayZone = (zone) => {
  weekdayToggleFields.forEach((fn) => {
    zone[fn] = !!zone[fn];
  });
  weekdayNumberFields.forEach((fn) => {
    const val = parseInt(zone[fn], 10);
    zone[fn] = Number.isNaN(val) || val < 0 ? 0 : val;
  });
};

/**
 * get zones info
 * @returns
 */
export const prepareZonesAfterLoad = (zones, tarifficatorType) => {
  if (!zones) {
    return {};
  }

  /**
   * get loop id for periodic
   * @param {*} periods
   * @returns
   */
  const getLoopId = (periods) => {
    return periods?.findIndex((el) => el.loop).toString();
  };

  const out = cloneDeep(zones);
  switch (tarifficatorType) {
    case 'two_periods':
      break;
    case 'igora':
      for (let zone in out) {
        out[zone].free_interval /= 60;
        igoraNumberFields.forEach((fn) => {
          out[zone][fn] /= 100;
        });
      }
      break;

    case 'tumen':
      for (let zone in out) {
        out[zone].free_interval /= 60;
      }
      break;

    case 'Daily':
      for (let zone in out) {
        dailyNumberFields.forEach((fn) => {
          out[zone][fn] /= 100;
        });
        out[zone].free_interval /= 60;
      }
      break;

    case 'HourlyDayNight':
      for (let zone in out) {
        hdnNumberFields.forEach((fn) => {
          out[zone][fn] /= 100;
        });
        if (out[zone].day_free_interval) {
          out[zone].day_free_interval /= 60;
        }
        if (out[zone].night_free_interval) {
          out[zone].night_free_interval /= 60;
        }
        out[zone].free_interval /= 60;
        out[zone].use_freeperiod = !out[zone].use_freeperiod;
      }
      break;

    case 'menskings':
      for (let zone in out) {
        out[zone].free_day_interval /= 60;
        out[zone].free_night_interval /= 60;
        menskingsNumberFields.forEach((fn) => {
          out[zone][fn] /= 100;
        });
      }
      break;
    case 'parma':
      for (let zone in out) {
        out[zone].free_interval /= 60;
        parmaNumberFields.forEach((fn) => {
          out[zone][fn] /= 100;
        });
      }
      break;
    case 'interval':
      for (let zone in out) {
        out[zone].free_interval /= 60;
        // out[zone].use_freeperiod = !out[zone].use_freeperiod;
        if (out[zone].intervals) {
          out[zone].intervals.forEach((period) => {
            period.amount = Math.round(period.amount / 100);
          });
        }
      }
      break;
    case 'weekday':
      for (let zone in out) {
        normalizeWeekdayZone(out[zone]);
        // kopecks -> rub, seconds -> min
        weekdayNumberFields.forEach((fn) => {
          out[zone][fn] = Math.round(out[zone][fn] / (fn.endsWith('_hour_cost') ? 100 : 60));
        });
      }
      break;
    case 'default':
      for (let zone in out) {
        if (out[zone].periods) {
          out[zone].fixprice = 0;
          const loopId = getLoopId(out[zone].periods);
          if (loopId !== '-1') {
            out[zone].loop = loopId;
          }

          out[zone].periods.forEach((period) => {
            if (period.count === undefined) {
              period.count = 1;
            }
            if (period.loop === undefined) {
              period.loop = false;
            }
            period.amount = Math.round(period.amount / 100);
            period.period /= 60;
          });
        }
      }

      break;
    default:
      break;
  }
  return out;
};

/**
 * prepare zones for save
 * @param {*} zones
 * @param {*} tarifficatorType
 * @returns
 */
export const prepareZonesForSave = (zones, tarifficatorType) => {
  if (!zones) {
    return {};
  }

  let out = cloneDeep(zones);

  switch (tarifficatorType) {
    // igora
    case 'igora':
      for (let zone in out) {
        out[zone].free_interval *= 60;
        igoraNumberFields.forEach((fn) => {
          out[zone][fn] *= 100;
        });
      }
      break;

    // tumen
    case 'tumen':
      for (let zone in out) {
        out[zone].free_interval *= 60;
      }
      break;

    // Daily
    case 'Daily':
      for (let zone in out) {
        dailyNumberFields.forEach((fn) => {
          out[zone][fn] *= 100;
        });
        out[zone].free_interval *= 60;
      }
      break;

    // HourlyDayNight
    case 'HourlyDayNight':
      for (let zone in out) {
        hdnNumberFields.forEach((fn) => {
          out[zone][fn] *= 100;
        });
        if (out[zone].day_free_interval) {
          out[zone].day_free_interval *= 60;
        }
        if (out[zone].night_free_interval) {
          out[zone].night_free_interval *= 60;
        }
        out[zone].free_interval *= 60;
        out[zone].use_freeperiod = !out[zone].use_freeperiod;
      }
      break;

    // menskings
    case 'menskings':
      for (let zone in out) {
        out[zone].free_day_interval *= 60;
        out[zone].free_night_interval *= 60;
        menskingsNumberFields.forEach((fn) => {
          out[zone][fn] *= 100;
        });
      }
      break;

    // parma
    case 'parma':
      for (let zone in out) {
        out[zone].free_interval *= 60;
        parmaNumberFields.forEach((fn) => {
          out[zone][fn] *= 100;
        });
      }
      break;

    // two periods tariffication
    case 'two_periods':
      for (let zone in out) {
        const periods = out[zone].periods;
        periods.forEach((period, index) => {
          out[zone].periods[index].amount = parseInt(period.amount) * 100;
          period.period *= 60;
        });
      }
      break;
    case 'interval':
      for (let zone in out) {
        out[zone].free_interval *= 60;
        // out[zone].use_freeperiod = !out[zone].use_freeperiod;
        if (out[zone].intervals) {
          out[zone].intervals.forEach((period) => {
            period.amount = Math.round(period.amount * 100);
          });
          out[zone].intervals.sort((a, b) => a.start_at.localeCompare(b.start_at));
        }
      }
      break;

    // weekday
    case 'weekday':
      for (let zone in out) {
        normalizeWeekdayZone(out[zone]);
        // rub -> kopecks, min -> seconds
        weekdayNumberFields.forEach((fn) => {
          out[zone][fn] *= fn.endsWith('_hour_cost') ? 100 : 60;
        });
      }
      break;

    // default tariffication
    case 'default':
      for (let zone in out) {
        // fix price
        if (out[zone].fixprice) {
          out[zone].fixprice *= 100;
        }

        // loop
        let loop;
        if (out[zone].loop !== undefined) {
          loop = parseInt(out[zone].loop);
          delete out[zone].loop;
        }

        const periods = out[zone].periods;
        let periodStartAt = 0;
        periods.forEach((period, index, array) => {
          period.amount = Math.round(period.amount * 100);
          period.period *= 60;
          if (period.count) {
            period.count = parseInt(period.count);
          }
          if (index === 0) {
            period.start_at = periodStartAt;
          } else {
            periodStartAt += array[index - 1].period * (array[index - 1].count ? array[index - 1].count : 1);
            period.start_at = periodStartAt;
          }
          // loop
          if (loop !== undefined) {
            period.loop = loop === index;
          }
          delete period.id;
        });
      }
      break;
    default:
      break;
  }

  return out;
};

/**
 * prepare tariff after load
 * @param {*} tariff
 * @returns
 */
export const prepareTariffAfterLoad = (tariff) => {
  const out = cloneDeep(tariff);
  const { time_to_leave } = out;

  // time to leave
  if (time_to_leave && time_to_leave % 60 === 0) {
    out.time_to_leave = time_to_leave / 60;
  }

  if (out.data) {
    // hack
    if (out.data.subscription_period === undefined) {
      out.data.subscription_period = 30;
    }

    // sec to min
    secondFields.forEach((fn) => {
      if (out.data[fn] !== undefined) {
        out[fn] = Math.round(out.data[fn] / 60);
        out.data[fn] = out[fn];
      }
    });
  }
  // console.log('🚀 ~ secondFields.forEach ~ out:', out);

  // if (zones) {
  //   for (let zone in zones) {
  //     if (Array.isArray(zones[zone].periods)) {
  //       zones[zone].periods.forEach((period) => {
  //         if (period.period) period.period = period.period / 60;
  //         if (period.start_at) period.start_at = period.start_at / 60;
  //         if (period.amount) period.amount = Math.round(period.amount) / 100; //period.amount / 100;
  //       });
  //     }
  //   }
  // }

  return out;
};

/**
 * prepare tariff for save
 * @param {*} tariff
 * @param {*} tarifficatorType
 */
export const prepareTariffForSave = (tariff, tarifficatorType) => {
  // clone
  const out = cloneDeep(tariff);

  // number
  numberFields.forEach((fn) => {
    if (out[fn] !== undefined) {
      out[fn] = Number(out[fn]);
    }
  });

  // min to sec
  secondFields.forEach((fn) => {
    if (out[fn] !== undefined) {
      out[fn] *= 60;
    }
  });

  // rub to kop
  priceFields.forEach((fn) => {
    if (out[fn] !== undefined) {
      out[fn] *= 100;
    }
  });

  if (out.vehicle_category) {
    out.vehicle_category = out.vehicle_category.map((el) => Number(el));
  } else {
    out.vehicle_category = [];
  }
  if (out.vehicle_class) {
    out.vehicle_class = out.vehicle_class.map((el) => Number(el));
  }

  out.zones = prepareZonesForSave(out.zones, tarifficatorType);
  return out;
};

/**
 * prepare form data from tariff
 * @param {*} tariff
 * @param {*} tarifficatorType
 * @returns
 */
export const prepareFormInitial = (tariff, tarifficatorType) => {
  const out = cloneDeep(tariff);
  const isIndividual = out.type === 'individual';
  delete out.time_to;
  delete out.parent;
  delete out.created_at;
  delete out.id;
  delete out.status;
  if (!isIndividual) {
    delete out.vehicle_class;
    delete out.vehicle_category;
  }

  if (out.data !== undefined) {
    dataFields.forEach((fn) => {
      if (out.data[fn] !== undefined) {
        out[fn] = out.data[fn];
      }
    });
  }

  priceFields.forEach((fn) => {
    out[fn] /= 100;
  });

  out.zones = prepareZonesAfterLoad(out.zones, tarifficatorType);

  return out;
};
